module.exports = __webpack_public_path__ + "static/media/use_esim_en4.9a24a83f.png";